var cilArrowThickTop = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M352.063,496h-192V295.993L16.047,296l.037-38.688L256.318,17.364,496,257.7v38.278l-143.937.006Zm-160-32h128V263.984l137.006-.006L256.274,62.636,54.672,264l137.391-.008Z' class='ci-primary'/>"];

export { cilArrowThickTop };

